import type { ComponentPropsWithAs } from '@/@types/common'
import clsx from 'clsx'
import type { AnchorHTMLAttributes, ElementType } from 'react'
import styles from './Link.module.css'

export interface LinkProps extends AnchorHTMLAttributes<HTMLAnchorElement> {}

export default function Link<As extends ElementType = 'a'>({
	as: AsComponent,
	className,
	...props
}: ComponentPropsWithAs<LinkProps, As>) {
	const Component = AsComponent ?? ('a' as ElementType)
	return <Component {...props} rel="noopener noreferrer" className={clsx(styles.root, className)} />
}
